<template>
    <div class="mt-20">     
        <v-card rounded="lg" outlined style="overflow: unset;">
            <div class="pa-20 pa-md-24">
                <v-row align="center" class="row--x-large">
                    <v-col cols="12" md="auto" class="mb-10 mb-md-0">
                        <v-checkbox v-model="isSelected" :value="true" @change="$emit('select', value)" hide-details />
                        <!-- <v-checkbox :value="isSelected" @change="$emit('select', value)" hide-details /> -->
                    </v-col>
                    <v-col cols="12" md="" class="worker-item__left">
                        <v-row align="center">
                            <v-col cols="12" lg="auto">
                                <v-row align="center">
                                    <v-col cols="auto">
                                        <v-avatar color="grey">
                                            <v-img :src="resume?.profile?.url" aspect-ratio="1 / 1">
                                                <v-fade-transition>
                                                    <v-icon v-show="!resume?.profile?.url">mdi-account</v-icon>
                                                </v-fade-transition>
                                            </v-img>
                                        </v-avatar>
                                        <!-- <v-avatar color="grey">
                                            <v-img :alt="resume?.profile?.url" aspect-ratio="1 / 1">
                                                <v-fade-transition>
                                                    <v-icon v-show="!resume?.profile?.url">mdi-account</v-icon>
                                                </v-fade-transition>
                                            </v-img>
                                        </v-avatar> -->
                                    </v-col>
                                    <v-col cols="auto">
                                        <v-row no-gutters align="center">
                                            <v-col cols="auto">
                                                <h5 class="page-text--lg font-weight-medium pr-4 pr-lg-0 min-w-lg-80px">
                                                    {{resume?.personalInformation?.name}}
                                                </h5>
                                            </v-col>
                                            <v-col cols="auto">
                                                <p class="page-text grey-9--text">
                                                    ({{resume?.personalInformation?.genderText}}, {{resume?.personalInformation?.age}})
                                                </p>                                    
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" lg="" class="worker-item__head-center">
                                <ul class="dot-texts">
                                    <li class="dot-text page-text grey-6--text ellip" v-for="text in cardTextList()" :key="text">
                                        · {{ text }}
                                    </li>
                                </ul>                            
                            </v-col>
                            <v-col cols="12" lg="auto">
                                <v-row class="row--small">
                                    <v-col cols="4" lg="auto">
                                        <v-btn small outlined block color="primary" @click="$refs['application-view'].shows = true">지원자 정보</v-btn>
                                    </v-col>
                                    <v-col cols="4" lg="auto">
                                        <v-btn 
                                            small outlined block color="secondary" 
                                            :disabled="employment?.place?.title === '해당없음'"
                                            @click="showCompanyStatus"
                                            >
                                            근무지 현황
                                        </v-btn>
                                    </v-col>
                                    <v-col cols="4" lg="auto">
                                        <v-btn 
                                        small outlined block color="secondary" 
                                        :disabled="employment?.place?.title === '해당없음'"
                                        @click="showPersonalStatus"
                                        >
                                        개인 근무 현황
                                    </v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-card rounded flat color="grey-f7" class="mt-10 mt-lg-16 mb-12 mb-lg-24">
                            <div class="pa-12 px-md-16 py-md-8">
                                <v-row align="center">
                                    <v-col cols="12" md="">
                                        <v-row align="center" class="page-text primary--text">
                                            <v-col cols="12" md="auto">
                                                <strong>계약서</strong>
                                            </v-col>
                                            <v-col cols="">
                                                <v-row class="row--small">
                                                    <v-col cols="auto">
                                                        <p>
                                                            {{value?.form?.name}}
                                                        </p>
                                                    </v-col>
                                                    <v-col cols="auto">
                                                        <p class="secondary--text">{{ value?.isSigned ? "서명 완료" : "서명 미완료"}}</p>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" md="auto">
                                        <worker-form :value="value">
                                            <template #activator="{ attrs, on }">
                                                <v-btn v-bind="attrs" v-on="on" small block color="primary">자세히 보기</v-btn>
                                            </template>
                                        </worker-form>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-card>
                        <v-row class="ma-n6">
                            <v-col cols="12" class="pa-6">
                                <v-row class="row--x-small">
                                    <v-col cols="12" md="auto">
                                        <p class="page-text font-weight-medium min-w-md-100px mt-md-6 mt-lg-8">근무지</p>
                                    </v-col>
                                    <v-col cols="12" md="">
                                        <v-select
                                            v-model="employment.place"
                                            v-bind="attrs_input"
                                            :items="places"
                                            item-text="title"
                                            itme-value="places"
                                            return-object
                                        />
                                    </v-col>
                                    <!-- <v-col cols="12" md="auto">
                                        <v-btn block color="primary">근무지 목록</v-btn>
                                    </v-col> -->
                                    <v-col cols="6" md="auto">
                                        <v-btn block outlined color="primary" @click="save">저장</v-btn>
                                    </v-col>
                                    <v-col cols="6" md="auto">
                                        <v-btn block outlined color="grey-d" @click="$emit('deleteContract',value._id)"><span class="grey-6--text">삭제</span></v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" lg="6" class="pa-6">
                                <v-row class="row--x-small">
                                    <v-col cols="12" md="auto">
                                        <p class="page-text font-weight-medium min-w-md-100px mt-md-6 mt-lg-8">근로 계약 기간</p>
                                    </v-col>
                                    <v-col>
                                        <v-row align="center" class="row--x-small">
                                            <v-col cols="12" xl="auto">  
                                                <v-row align="center" class="row--x-small">
                                                    <v-col>
                                                        <v-date-field :attach=false v-bind="attrs_input" textFieldClass="v-input--small" class="mw-lg-170px" v-model="employment.date.startsAt" :disabled="employment.date.fixedCheck"/>
                                                    </v-col>
                                                    <v-col cols="auto">
                                                        <p class="page-text page-text--sm">~</p>
                                                    </v-col>
                                                    <v-col cols="12" sm="">
                                                        <v-date-field :attach=false v-bind="attrs_input" textFieldClass="v-input--small" class="mw-lg-170px" v-model="employment.date.endsAt" :disabled="employment.date.fixedCheck"/>
                                                    </v-col>
                                                </v-row>                              
                                            </v-col>
                                            <v-col cols="12" xl="auto">
                                                <v-checkbox hide-details label="근로 기간의 정함이 없음" class="v-input--checkbox--lg" v-model="employment.date.fixedCheck"/>               
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" lg="6" class="pa-6">
                                <v-row class="row--x-small">
                                    <v-col cols="12" md="auto">
                                        <p class="page-text font-weight-medium min-w-md-100px mt-md-6 mt-lg-8">근로 시간</p>
                                    </v-col>
                                    <v-col>
                                        <v-row align="center" class="row--x-small">
                                            <v-col cols="12" xl="auto">  
                                                <v-row align="center" class="row--x-small">
                                                    <v-col>
                                                        <v-time-field :attach=false v-bind="attrs_input" textFieldClass="v-input--small" class="mw-lg-170px" v-model="employment.hour.startsAt" :disabled="employment.hour.fixedCheck" />
                                                    </v-col>
                                                    <v-col cols="auto">
                                                        <p class="page-text page-text--sm">~</p>
                                                    </v-col>
                                                    <v-col cols="12" sm="">
                                                        <v-time-field :attach=false v-bind="attrs_input" textFieldClass="v-input--small" class="mw-lg-170px" v-model="employment.hour.endsAt" :disabled="employment.hour.fixedCheck"/>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                            <v-col cols="12" xl="auto">
                                                <v-checkbox hide-details label="근로 기간의 정함이 없음" class="v-input--checkbox--lg" v-model="employment.hour.fixedCheck"/>               
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>                            
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </div>
            <application-view v-bind="{ 'value':value.application, recruitment }" @input="(item) => $emit('input', item)" ref="application-view" />
        </v-card>
    </div>
</template>

<script>
import api from '@/api';
import { attrs_input, } from "@/assets/variables";
import { EDUCATION_ATTENDING_STATUSES, EDUCATION_INSTITUTION_TYPES } from "@/assets/variables";

import ApplicationView from "../application/application-view.vue";
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
import VTimeField from "@/components/plugins/vuetify/v-time-field.vue";
import WorkerForm from './worker-form.vue';

export default {
    components: {
        VDateField,
        ApplicationView,
        VTimeField,
        WorkerForm
    },
    props:{
        value: { type: Object, default: () => ({}) }, //contract
        recruitment: { type: Object, default: () => ({}) },
        places : { type: Array, default: () => ([])},
        // isSelected: { type: Boolean, default: false},
        selectedApplicants: { type: Array, default: ()=>{[]}}
    },
    data: () => ({
        attrs_input,
        isSelected: false,
    }),
    computed:{
        resume(){
            return this.value?.application?.resume
        },

        employment(){
            return this.value?.employment
        }
    },
    mounted(){
    },
    methods:{
        area() {
            let { address1, address2 } = this.value?.application?.resume?.personalInformation?.residence || {};
            return `${address1} ${address2}`;
        },
        education() {
            let { institutionType, attendingStatus } = this.value?.application?.resume?.education || {};

            let education = "";
            if (institutionType) education += `${EDUCATION_INSTITUTION_TYPES[institutionType]?.text || ""} `;
            if (attendingStatus) education += `${EDUCATION_ATTENDING_STATUSES[attendingStatus]?.text || ""} `;
            return education.trim();
        },
        cardTextList() {
            return [this.value?.application?.resume?.personalInformation?.phone, this.area(), this.education()];
        },
        async save(){
            try{
                let { value } = this;
                value.employment.place._place = value?.employment?.place?._id;
                await api.v1.company.employment.contracts.put(value);

                alert('저장되었습니다.');
            } catch (e){
                console.error(e);
            }
        },
        showPersonalStatus(){
            this.$router.push(`/dashboard/worker/personal/${this.value._id}`);
        },
        showCompanyStatus(){
            this.$router.push(`/dashboard/worker/company/${this.value?.employment?.place?._place}`);
        }
    },
    watch: {
        "value.employment.hour.fixedCheck"(){
            this.value.employment.hour.startsAt = null;
            this.value.employment.hour.endsAt = null;
        },
        "value.employment.date.fixedCheck"(){
            this.value.employment.date.startsAt = null;
            this.value.employment.date.endsAt = null;
        },
        selectedApplicants(){
            const isInValue = this.selectedApplicants.some(({ _id }) => _id == this.value._id);
            this.isSelected = isInValue;
        }
    },
}
</script>

<style lang="scss" scoped>
@media (min-width:576px){
}
@media (min-width:768px){
    .worker-item{
        &__left{
            max-width: calc(100% - 34px);
        }
    }
}
@media (min-width:1024px){
    .worker-item{
        &__left{
            max-width: calc(100% - 84px);
        }
        &__head-center{
            max-width: calc(100% - 244px - 330px);
        }
    }
}
@media (min-width:1200px){
}
.theme--light.v-input.secondary--text{
    ::v-deep input{
        color: var(--v-secondary-base);
    }
}
.row--x-small {
    margin: -4px;
}
.row--x-small>[class*=col] {
    padding: 4px;
}
.v-btn:not(.v-btn--fab,.v-btn--icon,.v-btn--text).v-size--default {
    height: 32px;
    padding: 0 12.4444444444px;;
}
@media (min-width: 1024px){
    .v-btn:not(.v-btn--fab,.v-btn--icon,.v-btn--text).v-size--default {
        height: 40px;
        padding: 0 16px;
    }
}
</style>